<template>
  <div
    v-if="hasSufficientContrast"
    class="indicator d-flex flex-column justify-center align-center"
    :style="{ backgroundColor: selectedColor, color: '#ffffff' }"
  >
    <div
      class="text-center"
      v-html="$t('alerts.contrast-indicator.success')"
    />
    <v-icon
      class="py-4"
      size="large"
      color="white"
    >
      mdi-check
    </v-icon>
  </div>
  <div
    v-else
    class="indicator d-flex flex-column justify-center align-center"
    :style="{ backgroundColor: selectedColor, color: '#ffffff' }"
  >
    <div
      class="text-center text-body-2"
      v-html="$t('alerts.contrast-indicator.error')"
    />
  </div>
</template>

<script>
export default {
  props: {
    selectedColor: {
      type: String,
      default: '#000000',
    },
    hasSufficientContrast: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.indicator {
  width: 192px;
  height: 192px;
  border-radius: 50%;
}
.indicator__failure {
  background-color: #d0648136;
  border: 2px solid red;
  color: red;
}
</style>
